export default "__VITE_ASSET__BhDRwloH__"